import { Budget, Customer, CustomerType, HoardOrder, SaleOrder } from "./types"

export enum ActionType {
    SET_SALES = 'setSales',
    UPDATE_SALES = 'updateSales',
    REMOVE_SALES = 'removeSales',
    UPDATE_BUDGETS = 'updateBudgets',
    REMOVE_BUDGETS = 'removeBudgets',
    SET_HOARDS = 'setHoards',
    UPDATE_HOARDS = 'updateHoards',
    REMOVE_HOARDS = 'removeHoards',
    SET_CUSTOMERS = 'setCustomers',
    UPDATE_CUSTOMERS = 'updateCustomers',
    REMOVE_CUSTOMERS = 'removeCustomers',
    SET_CUSTOMER_TYPES = 'setCustomerTypes',
    UPDATE_CUSTOMER_TYPES = 'updateCustomerTypes',
    REMOVE_CUSTOMER_TYPES = 'removeCustomerTypes'
}

interface SetSales {
    type: ActionType.SET_SALES
    payload: SaleOrder[]
}

interface UpdateSales {
    type: ActionType.UPDATE_SALES
    payload: SaleOrder[]
}

interface RemoveSales {
    type: ActionType.REMOVE_SALES
    payload: string[]
}

interface UpdateBudgets {
    type: ActionType.UPDATE_BUDGETS
    payload: Budget[]
}

interface RemoveBudgets {
    type: ActionType.REMOVE_BUDGETS
    payload: string[]
}

interface SetHoards {
    type: ActionType.SET_HOARDS
    payload: HoardOrder[]
}

interface UpdateHoards {
    type: ActionType.UPDATE_HOARDS
    payload: HoardOrder[]
}

interface RemoveHoards {
    type: ActionType.REMOVE_HOARDS
    payload: string[]
}

interface SetCustomers {
    type: ActionType.SET_CUSTOMERS
    payload: Customer[]
}

interface UpdateCustomers {
    type: ActionType.UPDATE_CUSTOMERS
    payload: Customer[]
}

interface RemoveCustomers {
    type: ActionType.REMOVE_CUSTOMERS
    payload: string[]
}

interface setCustomerTypes {
    type: ActionType.SET_CUSTOMER_TYPES
    payload: CustomerType[]
}

interface UpdateCustomerTypes {
    type: ActionType.UPDATE_CUSTOMER_TYPES
    payload: CustomerType[]
}

interface RemoveCustomerTypes {
    type: ActionType.REMOVE_CUSTOMER_TYPES
    payload: string[]
}

export type SalesAction =
    SetSales |
    SetHoards |
    SetCustomers |
    setCustomerTypes |
    SalesUpdateAction |
    SalesRemoveAction

export type SalesUpdateAction =
    UpdateSales |
    UpdateBudgets |
    UpdateHoards |
    UpdateCustomers |
    UpdateCustomerTypes

export type SalesRemoveAction =
    RemoveSales |
    RemoveBudgets |
    RemoveHoards |
    RemoveCustomers |
    RemoveCustomerTypes
